import 'swiper/scss';
import 'swiper/scss/pagination';
import * as diapoPresStyles from "../../../styles/internal-page/diapoPres.module.scss";

import React from "react";
import { useTranslation } from "react-i18next";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Pagination} from "swiper";
import IconContainer from "../IconContainer";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import clsx from 'clsx';

SwiperCore.use([Pagination]);

const DiapoPres = ({
	content,
}) => {
	const {t} = useTranslation();
	const paginationRef = React.useRef(null);
	const [swiper, setSwiper] = React.useState(null);
	const [display, setDisplay] = React.useState(false);

	React.useEffect(() => {
		setDisplay(true)
	}, [])

	if (!content.testimonies || content.testimonies.length === 0) {
		return (
			<></>
		)
	}

	if (content.testimonies.length === 1){
		return (
			<div className={diapoPresStyles.container}>
				{content.testimonies[0].picture && <div className={diapoPresStyles.containerImage}>
					<GatsbyImage
						loading="eager"
						className={diapoPresStyles.image}
						image={getImage(content.testimonies[0].picture?.imageFile)}
						alt={""}
					/>
				</div>}
				<div className={diapoPresStyles.containerText}>
					{content.testimonies[0].children}
				</div>
			</div>
		)
	}
	return (
		<div className={diapoPresStyles.root}>
			<div className={diapoPresStyles.thumbnailMargin}>
				<ul
						ref={paginationRef}
						aria-label={t("carrousel.chips")}
						style={{display: "flex", width: "auto"}}
				>
				</ul>
			</div>
			{display && <button
				className={diapoPresStyles.leftArrowDiaporamaTest}
				tabIndex="0"
				onKeyDown={(e) => {
					e.currentTarget.click()
				}}
				onClick={() => {
					swiper.slidePrev()
				}}
				aria-label={t("carrousel.leftArrow")}
			>
				<IconContainer
					svgClassname={diapoPresStyles.svg}
					icon="ARROW_LEFT_LARGE"
					color="RED"
					variant="contained"
					size={20}
				/>
			</button>}
			{display && <button
				className={diapoPresStyles.rightArrowDiaporamaTest}
				tabIndex="0"
				onKeyDown={(e) => {
					e.currentTarget.click()
				}}
				onClick={() => {
					swiper.slideNext()
				}}
				aria-label={t("carrousel.rightArrow")}
			>
				<IconContainer
					svgClassname={diapoPresStyles.svg}
					icon="ARROW_RIGHT_LARGE"
					color="RED"
					variant="contained"
					size={20}
				/>
			</button>}
			<Swiper
				pagination={{
						el: paginationRef.current,
						clickable: true,
						bulletElement: 'li',
						bulletClass: diapoPresStyles.thumbnails,
						bulletActiveClass: diapoPresStyles.thumbnailsActive,
				}}
				centeredSlides={true}
				speed={600}
				spaceBetween={2}
				loop
				autoHeight
				slidesPerView={1}
				onSwiper={(core) => setSwiper(core)}
				style={{width: "100%"}}
				className={clsx({[diapoPresStyles.inLoadContainer]: !display})}
			>
				{content?.testimonies?.map((item, index) => (
					<SwiperSlide
						key = {index}
					>
						<div className={diapoPresStyles.container}>
							{item.picture && <div className={diapoPresStyles.containerImage}>
								<GatsbyImage
									loading="eager"
									className={diapoPresStyles.image}
									image={getImage(item.picture?.imageFile)}
									alt={""}
								/>
							</div>}
							<div className={diapoPresStyles.containerText}>
								{item.children}
							</div>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default DiapoPres;
